export default __webpack_public_path__ + "static/media/inst1.71d04baf.jpg";